import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DashboardService } from '../dashboard.service';
import {Location} from '@angular/common';

@Component({
    selector: 'app-review-users',
    templateUrl: './review-users.component.html',
    styleUrls: ['./review-users.component.css'],
    standalone: false
})
export class ReviewUsersComponent implements OnInit {

  userId = '';
  parameters: any[] = [];
  constructor(private route: ActivatedRoute,
              private dashboardService: DashboardService,
              private _location: Location) { }

  ngOnInit(): void {
    this.route.params.subscribe(params => this.userId = params["id"]);
    this.getReviews();
  }

  getReviews(): void {
    this.dashboardService.getRatingsByUser(this.userId).subscribe((data) => {
      this.parameters = data;
    });
  }

  remove(id: string, i): void {
    this.dashboardService.deleteRatings(id).subscribe((data) => {
      this.parameters.splice(i, 1);
    });
  }

  goBack(): void {
    this._location.back();
  }
}
